import { Link } from 'react-router-dom'

const Error = () => {
    return(
        <div className="ui grid middle aligned segment white inverted" style={{height: "100%", margin: '0'}}>
            <div className="ui column center aligned">
                <div className="ui inverted statistic">
                <div className="value">404</div>
                <div className="label">Error</div>
                </div>

                <div className="ui message red inverted">
                <div className="header">The Page You are looking For does Not Exist</div>
                <Link to="/">Go Back</Link>
                </div>
            </div>
         </div>
    )
}

export default Error